import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Dashboard from './components/Dashboard';
import { EnhancedAddAPI } from './components/EnhancedAddAPI';
import { APIDetailsFixed } from './components/APIDetailsFixed';
import EditAPI from './components/EditAPI';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>LLM API Registry</h1>
        <nav className="responsive-nav" role="navigation">
          <ul>
            <li>
              <a href="/">Dashboard</a>
            </li>
            <li>
              <a href="/add">Add API</a>
            </li>
          </ul>
        </nav>
      </header>
      
      <main role="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/add" element={<EnhancedAddAPI />} />
          <Route path="/api/:id" element={<APIDetailsFixed />} />
          <Route path="/edit/:id" element={<EditAPI />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
